import { app } from '../../../../../app';
import { Controller } from './manage-shared-password.controller';

app.component('companySharingCenterSharedPasswordsManage', {
	bindings: {
        publicServicesWithSso$:'<',
        sharedAccount: '<',
        companyId: '<',
        allAccounts: '<',
        convert2fa: '<'
    },
    //bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./manage-shared-password.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/manage/manage-shared-password.component.js